<template>
	<div class="bg-white custom-shadow">
		<q-parallax :height="130">
			<template v-slot:media>
				<img :src="getBanner" />
			</template>

			<div class="custom-container">
				<q-breadcrumbs class="bc-text text-weight-bold">
					<template v-slot:separator>
						<q-icon size="1.2em" name="fal fa-chevron-right" color="white" />
					</template>

					<q-breadcrumbs-el icon="fal fa-home" :label="$t('home')" :to="{ name: 'home' }" />
				</q-breadcrumbs>

				<span class="text-h3 text-white">{{ $t(getPageName) }}</span>
			</div>
		</q-parallax>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Breadcrumbs',

	computed: {
		...mapGetters({
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getBanner() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})

			if (obj && obj.home_banner && obj.home_banner !== 'https://image.jpg') return obj.home_banner
			else return ''
		},

		getPageName() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})

				if (obj) {
					switch (this.$route.meta.title) {
						case 'library':
							return obj.title_library == '' ? 'library' : obj.title_library
							break
						case 'news':
							return obj.title_news == '' ? 'news' : obj.title_news
							break
						case 'faq':
							return 'frequently_asked_questions'
							break
						case 'support':
							return 'support'
							break
						case 'privacy_policy':
							return 'privacy_policy'
							break
						case 'cookies_policy':
							return 'cookies_policy'
							break
						case 'terms_and_conditions':
							return 'terms_and_conditions'
							break
						case 'about':
							return 'about'
							break
					}
				}
			} else return ''
		},
	},
}
</script>

<style></style>
